import store from '../../../store'
import { intl } from '../../../i18n'
import { AiAgentWbsItemRef } from '../../../lib/functions/ai'
import {
  MAX_WBS_ITEM_ATTACHMENTS,
  addWbsItemAttachments,
  countWbsItemAttachmentsRejectedByLimit,
  requestOpenChat,
  selectWbsItemAttachments,
} from '../../../store/aiAgentChat'
import { addGlobalMessage, MessageLevel } from '../../../store/messages'

/**
 * 画面側からAIエージェントチャットへWBSアイテムを添付する（push型）。
 * チャットは画面のローカル状態をpullできない（usePageContext.ts の rootWbsItem 未実装の
 * TODO参照）ため、添付操作は画面側のこの関数を通じてReduxへdispatchする。
 * 上限（MAX_WBS_ITEM_ATTACHMENTS件）を超える分は追加されず、その場合はトーストで知らせる。
 * 添付に成功したかどうかにかかわらずチャットを開く（既に添付済みだった場合も、
 * ユーザーは添付操作をした以上その一覧を見たいはずのため）。
 */
export const attachWbsItemsToAiAgentChat = (items: AiAgentWbsItemRef[]) => {
  if (items.length === 0) return

  const current = selectWbsItemAttachments(store.getState())
  const rejectedCount = countWbsItemAttachmentsRejectedByLimit(current, items)

  store.dispatch(addWbsItemAttachments(items))
  // 添付しただけでは何が添付されたか分からないため、チャットを開いて添付内容を見せる。
  // 起動ボタンを引っ込めている状態でも常設状態に戻す（AiAgentChatが要求を受けて行う）。
  store.dispatch(requestOpenChat())

  if (rejectedCount > 0) {
    store.dispatch(
      addGlobalMessage({
        type: MessageLevel.WARN,
        title: intl.formatMessage(
          { id: 'aiAgentChat.attach.wbsItem.limitExceeded' },
          { limit: MAX_WBS_ITEM_ATTACHMENTS }
        ),
      })
    )
  }
}
